import http from '../../../../api/http';

const BASE_URL = '/admin/corporationInfo';
const API_URL = `${BASE_URL}`;

// 기업홍보관 공개여부
function updateStatusCorpInfoOpenYn(params) {
    return http.post(`${API_URL}/updateStatusCorpInfoOpenYn`, params)
}

// 기업정보등록, 마스터회원 등록 유무
function retrieveCorpInfoYnAndMasterMemberYnByCorpId(corpId) {
    return http.get(`${API_URL}/retrieveCorpInfoYnAndMasterMemberYnByCorpId?corpId=${corpId}`)
}

// 기업 회원 조회
function retrieveCorpEmpListPaging(params) {
    return http.post(`${API_URL}/retrieveCorpEmpListPaging`, params)
}

// 기업관리 > 기업목록 > 기업홍보관 입사지원 현황 (TAB) 조회
function retrieveApplicantListPagingByCorpId(params) {
    return http.post(`${API_URL}/applicant/retrieveApplicantListPagingByCorpId`, params)
}

// 기업관리 > 기업홍보관 입사지원 현황 조회
function retrieveAllCorpInfoApplicantPaging(params) {
    return http.post(`${API_URL}/applicant/retrieveAllCorpInfoApplicantPaging`, params)
}

// 회원관리 > 회원목록 > 기업홍보관 입사지원 현황 (TAB) 조회
function retrieveApplicantListPagingByUserId(params) {
    return http.post(`${API_URL}/applicant/retrieveApplicantListPagingByUserId`, params)
}


export default {
    updateStatusCorpInfoOpenYn,
    retrieveCorpInfoYnAndMasterMemberYnByCorpId,
    retrieveCorpEmpListPaging,
    retrieveApplicantListPagingByCorpId,
    retrieveAllCorpInfoApplicantPaging,
    retrieveApplicantListPagingByUserId,
};
